import React, { useRef } from "react";
import ProjectTableCell from "./ProjectTableCell";
import { useSearchParams } from "react-router-dom";

function ProjectTableRow(props) {
  const { tableConfig, rowData } = props;

  const [searchParams] = useSearchParams();
  const quotationId = searchParams.get("quotationId")
  const planId = searchParams.get("planId")
  const requestId = searchParams.get("requestId")
  const sampleId = searchParams.get("sampleId")
  const reportId = searchParams.get("reportId")
  const invoiceId = searchParams.get("invoiceId")
  const caseId = searchParams.get("caseId")

  const getHighlight = (cellConfig, index) => {
    switch (cellConfig?.dataKey) {
      case 'caseId':
        return caseId && caseId === rowData.item?._id;
      case 'quotation':
        return quotationId && quotationId === rowData.item?._id;
      case 'requestForm':
        return requestId && requestId === rowData.item?._id;
      case 'testPlan':
        return planId && planId === rowData.item?._id;
      case 'report':
        return reportId && reportId === rowData.item?._id;
      case 'invoice':
        return invoiceId && invoiceId === rowData.item?._id;
      case 'sampleStatus':
        return sampleId && sampleId === rowData.item?._id;
      default:
        return false;
    }
  }

  return (
    <div className="w-full h-[32px] flex">
      {Array.isArray(tableConfig) && tableConfig.map((cellConfig, index) => {
        const highlight = getHighlight(cellConfig, index)

        return cellConfig.CustomTableCell ?
          <cellConfig.CustomTableCell
            key={index}
            width={cellConfig.width}
            textAlign={cellConfig.textAlign}
            cellContent={
              rowData?.[cellConfig.dataKey] !== undefined
                ? rowData?.[cellConfig.dataKey]
                : ""
            }
            rowData={cellConfig.dataKey === "caseStatus" ? rowData : null}
            caseId={rowData.id}
            highlight={highlight}
          />
          :
          <ProjectTableCell
            key={index}
            width={cellConfig.width}
            textAlign={cellConfig.textAlign}
            cellContent={
              rowData?.[cellConfig.dataKey] !== undefined
                ? rowData?.[cellConfig.dataKey]
                : ""
            }
            highlight={highlight}
          />
      })
      }
    </div>
  );
}

export default ProjectTableRow;
